import { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import {
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import AlertModal from './AlertModal';

const ECReCaptcha = (props) => {
    const [captchaToken, setCaptchaToken] = useState('')
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [showCantVerify, setShowCantVerify] = useState(false);

    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');

            return;
        }

        const token = await executeRecaptcha('yourAction');
        // Do whatever you want with the token
        setCaptchaToken(token);
        props.handleToken(token);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [executeRecaptcha]);

    // You can use useEffect to trigger the verification as soon as the component being loaded
    useEffect(() => {
        handleReCaptchaVerify();
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<>
        {!captchaToken ? <Button variant={'secondary'} onClick={handleReCaptchaVerify}>Verify recaptcha</Button> : <p>Captcha Verified</p>}
        <AlertModal 
            show={showCantVerify}
            handleClose={() => setShowCantVerify(false)}
            confirmButton={"Close"}
            modalBody={'The browser cant verify captcha. Please reload the page.'}
        ></AlertModal>
    </>);
};

export default ECReCaptcha;